// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UnfoldMoreIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UnfoldMoreIcon" ref={forwardedRef} {...props}>
      <path d="M5.756 12.757 10 17l4.243-4.243-1.06-1.06L10 14.879l-3.182-3.182z" />
      <path d="M14.242 7.243 10 3 5.757 7.243l1.06 1.06L10 5.121l3.182 3.182z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UnfoldMoreIcon = /* @__PURE__ */ Object.assign(
  UnfoldMoreIconComponent,
  { displayName: 'UnfoldMoreIcon' },
);
